import * as React from 'react';

export interface IEntityTabContentProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}

export default function EntityTabContent(props: IEntityTabContentProps) {
	const { children, value, index } = props;
	return <>{value === index && children}</>;
}
